import React from "react";
import { BrowserRouter, Switch, Redirect, Route } from "react-router-dom";

import Index from "./pages/index";
import OurStory from "./pages/our-story";
import Services from "./pages/services";
import Blog from "./pages/blog";
import SingleBlog from "./pages/single-blog";
import Event from "./pages/event";
import SingleEvent from "./pages/single-event";
import Contact from "./pages/contact";
import ProspectiveInternationalStudent from "./pages/prospective-international-student";
import CurrentInternationalStudent from "./pages/current-international-student";

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Redirect exact path="/" to="/home" />
        <Route exact path="/home" component={Index} />
        <Route exact path="/our-story" component={OurStory} />
        <Route exact path="/services" component={Services} />
        <Route exact path="/resources" component={Blog} />
        <Route path="/resources/article/:id" component={SingleBlog} />
        <Route exact path="/events" component={Event} />
        <Route path="/events/:id" component={SingleEvent} />
        <Route exact path="/contact" component={Contact} />
        <Route
          exact
          path="/prospective-international-student"
          component={ProspectiveInternationalStudent}
        />
        <Route
          exact
          path="/current-international-student"
          component={CurrentInternationalStudent}
        />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
